import { styled } from "@mui/material";
import { EditorToolbar } from "../../EditorToolbar/index.js";
import { editorName } from "../classes.js";
const Toolbar = styled(EditorToolbar, {
  name: editorName,
  slot: "Toolbar",
  overridesResolver: (_, styles) => styles.toolbar
})(({ theme, ownerState }) => ({
  ...ownerState?.error && {
    borderColor: (theme.vars ?? theme).palette.error.main
  }
}));
export {
  Toolbar
};
//# sourceMappingURL=Toolbar.js.map
